import { memo } from "react";
import { useCallback } from "react";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { selectAll } from "../features/websites/websitesSlice";
import { FullScreenIcon } from "../pages/client/acquisition";
import DefaultBtn from "./elements/Buttons/DefaultBtn";
import { EmptyMessage } from "./EmptyMessage";

/**
 * 
 * @param {{activeWebsite: Website | null, websites: Websites[]}} props 
 * @returns {JSX.Element}
 */
const Dataviz = ({ activeWebsite, src = 'https://azatys.clicdata.com/v/s47fsYhq6oox?website_id=' }) => {
  const websites = useSelector(selectAll)

  const toggleFullScreen = useCallback(async (e) => {
    if (!document.fullscreenEnabled) return
    if (!document.fullscreenElement) if (e?.type === 'click' || e?.key?.toLowerCase() === 'f') await document.querySelector('iframe#dataviz-indicator').requestFullscreen()
    else await document.exitFullscreen()
  }, [])

  useEffect(() => {
    if (!activeWebsite) return
    document.addEventListener('keydown', toggleFullScreen)

    return () => document.removeEventListener('keydown', toggleFullScreen)
  }, [activeWebsite])

  return (
    <div className="w-full mx-auto px-10 relative flex flex-col items-center justify-center space-y-0.5 bg-gray-50">
      {activeWebsite &&
        <div className="max-w-5xl mx-auto w-full text-right absolute -top-32 lg:-top-28 right-2 lg:right-14">
          <DefaultBtn
            type='button'
            Icon={FullScreenIcon}
            label="Plein écran"
            disabled={!document.fullscreenEnabled}
            description={document.fullscreenEnabled ? "Raccourci: Appuyez sur la touche (f)" : "Votre navigateur ne supporte pas cette option."}
            onClick={toggleFullScreen}
          />
        </div>}
      {
        activeWebsite ? <div className='overflow-hidden min-w-full h-[100vh] transition duration-300'>
          <iframe
            className="rounded-b-3xl w-[100%] h-[100%]"
            id='dataviz-indicator'
            src={src + activeWebsite?.id}
          >
          </iframe>
        </div> :
          websites.length > 0 ? <EmptyMessage title='Selectionner un site !' message='Cliquez sur un site dans le menu au dessus pour afficher son tableau de bord.' /> :
            <EmptyMessage title="Vous n'avez enregistré aucun site !" message='Vérifiez que vous avez enregistré au moins un site pour avoir accès à son tableau de bord.' />
      }
    </div>
  );
};

export default memo(Dataviz);
